import React from "react";

export function ContactDetails(props) {  

  return (
    <div className="contact-details" id="contact-details">
      <h2 className="h1">{props.data.title}</h2>
      <div className="contact-details__list">
        {
          props.data.items.map((item, i) => (

            <a key={i}
              href={item.href}
              className="contact-details__list-item">
              <div className="contact-details__list-icon">
                <i className={`agi ${item.iconId}`}></i>
              </div>
              <div className="contact-details__list-text">
                {item.subtitle?.length > 0 &&
                  <small>{item.subtitle}</small>
                }
                <p>{item.title}</p>
              </div>
            </a>

          ))
        }

      </div>
    </div>
  );
}
